import { createFileRoute } from "@tanstack/react-router";
import { createOrgRedirectWithParams } from "@/common/utils/orgRouteUtils";

export const Route = createFileRoute("/_org/org/provider-profile/$userId/")({
  ...createOrgRedirectWithParams(
    "/org/bu/$organizationBusinessUnitId/provider-profile/$userId",
    ["userId"],
  ),
});
